import React from 'react';
import { CloudCheckIcon, CloudOffIcon, CloudUploadIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
export function SyncStatus() {
  const {
    pendingSyncCount,
    offline
  } = useAppState();
  if (offline) {
    return <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-excused-soft px-2.5 py-1 text-xs font-bold text-excused-ink" data-id="element-929" data-mp="vs3uea2tkg8o">
        <CloudOffIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-930" data-mp="15ndyd3cs2xp3" />
        Brez povezave{pendingSyncCount > 0 ? ` · ${pendingSyncCount} čaka` : ''}
      </span>;
  }
  if (pendingSyncCount > 0) {
    return <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-info-soft px-2.5 py-1 text-xs font-bold text-info-ink" data-id="element-931" data-mp="1entv7tz0n6kz">
        <CloudUploadIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-932" data-mp="3ggi6mqltd0bu" />
        Sinhroniziram…
      </span>;
  }
  return <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold text-muted" data-id="element-933" data-mp="3cfoh5ssq3dgu">
      <CloudCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-934" data-mp="2gy30bfo4x0i" />
      Sinhronizirano
    </span>;
}